export default "__VITE_ASSET__YfaZePv3__"